import { render, staticRenderFns } from "./Query2.vue?vue&type=template&id=0cd76624&scoped=true&"
import script from "./Query2.vue?vue&type=script&lang=js&"
export * from "./Query2.vue?vue&type=script&lang=js&"
import style0 from "./Query2.vue?vue&type=style&index=0&id=0cd76624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd76624",
  null
  
)

export default component.exports